







"use strict";

function chain(deferred, cb) {
    return (...args) => {
        try {
            let ret = cb(...args); 
            deferred.resolve(ret);
        } catch (err) {
            deferred.reject(err);
        }
    };
}

function toChainableAjax(p) {
    let then = p.then.bind(p);
    p.then = (cb1, cb2, cb3) => {
        let deferred = $.Deferred();
        then(chain(deferred, cb1),
             cb2 ? chain(deferred, cb2) : deferred.reject,
             cb3 || deferred.notify);
        return toChainableAjax(deferred.promise());
    };
    p.catch = cb => {
        let deferred = $.Deferred();
        then(deferred.resolve, chain(deferred, cb));
        return toChainableAjax(deferred.promise());
    };
    p.finally = cb => {
        let deferred = $.Deferred();
        let func = chain(deferred, cb);
        then(func, func);
        return toChainableAjax(deferred.promise());
    };
    return p;
}

function toAjaxPromise(p) {
    let then = p.then.bind(p);
    p.then = (cb1, cb2) => {
        let f1 = cb1 ? xhr =>
            cb1(xhr.response, xhr.status, xhr)
        : Promise.resolve.bind(Promise);
        let f2 = cb2 || Promise.reject.bind(Promise);
        let p2 = then(f1, f2);
        return toAjaxPromise(p2);
    };

    p.done = (...cbs) => {
        cbs.forEach(p.then.bind(p));
        return p;
    };
    p.fail = (...cbs) => {
        cbs.forEach(p.catch.bind(p));
        return p;
    };
    return p;
}











function ajax(options) {
    if (typeof $ === "function") {
        options = Object.assign(options);
        let promise = $.ajax(options);
        return toChainableAjax(promise);
    } else {
        let promise = new Promise((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open((options.type || "GET"), options.url, true);
            if (options.dataType) {
                xhr.responseType = options.dataType;
            }
            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(xhr);
                    } else {
                        let err = new Error(`xhr error: ${xhr.statusText}`);
                        err.status = xhr.status;
                        err.body = xhr.responseText;
                        err.xhr = xhr;
                        reject(err);
                    }
                }
            };
            if (options.headers) {
                for (let key of Object.keys(options.headers)) {
                    xhr.setRequestHeader(key, options.headers[key]);
                }
            }
            xhr.send(options.data);
        });

        return toAjaxPromise(promise);
    }
}

module.exports = {
    ajax
};
